import type { ExternalTableSchema } from '@packages/table-builder';

export const ADVISOR_API_CREDENTIAL_STATUS = {
  Active: 1,
  Revoked: 2,
} as const;

export const advisorApiCredentialTableSchema: ExternalTableSchema = {
  metadata: {
    title: 'Advisor API Keys',
    entity: 'AdvisorApiCredential',
  },

  dataSource: {
    endpoint: '/api/identity/api/app/advisor-api-credential',
    method: 'GET',
    rowIdField: 'id',
  },

  columns: [
    {
      field: 'apiKeyPrefix',
      header: 'Key Prefix',
      sortable: true,
      width: 180,
      visibility: 'locked',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 120,
      align: 'center',
      conditionalValues: {
        '1': 'Active',
        '2': 'Revoked',
      },
      badge: {
        statusMap: {
          Active: 'success',
          Revoked: 'error',
        },
      },
    },
    {
      field: 'effectiveFrom',
      header: 'Effective From',
      type: 'date',
      sortable: true,
      width: 150,
    },
    {
      field: 'effectiveTo',
      header: 'Effective To',
      type: 'date',
      sortable: true,
      width: 150,
    },
  ],

  actions: {
    row: [
      {
        id: 'EDIT_ADVISOR_API_KEY',
        label: 'Edit Dates',
        visibilityCondition: {
          field: 'status',
          operator: 'EQUAL',
          value: ADVISOR_API_CREDENTIAL_STATUS.Active,
        },
      },
      {
        id: 'REVOKE_ADVISOR_API_KEY',
        label: 'Revoke',
        variant: 'danger',
        visibilityCondition: {
          field: 'status',
          operator: 'EQUAL',
          value: ADVISOR_API_CREDENTIAL_STATUS.Active,
        },
      },
    ],
    toolbar: {
      primary: {
        id: 'CREATE_ADVISOR_API_KEY',
        label: 'Generate API Key',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'clientSide', defaultSize: 25 },
    columnPreferences: {
      persistenceKey: 'AdvisorApiCredential',
      resizable: true,
      reorderable: true,
    },
  },
};
